import { useInfiniteQuery } from '@tanstack/react-query';
import { getBits, getFollowedBits, getSubscribedBits } from '@/src/actions/bits';

export function useProfileBits(
  uniqueLink: string,
) {
  return useInfiniteQuery({
    queryKey: ['profileBits', uniqueLink],
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getBits(null, pageParam, 20, uniqueLink);
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.bits.length === 20 ? pages.length + 1 : undefined;
    },
  });
}

export function useDiscoverBits(
  enabled: boolean,
  activeTag: string,
  searchText: string
) {
  return useInfiniteQuery({
    queryKey: ['discoverBits', activeTag, searchText],
    enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getBits(null, pageParam, 20, undefined, activeTag, searchText);
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.bits.length === 20 ? pages.length + 1 : undefined;
    },
  });
}

export function useFollowedBits(
  enabled: boolean,
  activeTag: string,
  searchText: string
) {
  return useInfiniteQuery({
    queryKey: ['followedBits', activeTag, searchText],
    enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getFollowedBits(pageParam, 20, activeTag, searchText);
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.bits.length === 20 ? pages.length + 1 : undefined;
    },
  });
}

export function useSubscribedBits(
  enabled: boolean,
  activeTag: string,
  searchText: string
) {
  return useInfiniteQuery({
    queryKey: ['subscribedBits', activeTag, searchText],
    enabled,
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      return getSubscribedBits(pageParam, 20, activeTag, searchText);
    },
    getNextPageParam: (lastPage, pages) => {
      const bitsLength = lastPage?.bits?.length ?? 0;
      return bitsLength === 20 ? pages.length + 1 : undefined;
    },
  });
}
